import React from 'react';
import PropTypes from 'prop-types';
import { LEGEND_COLORS } from '../../../../reports-constants';
import style from './qqModuleHeroCard.module.css';
import { roundtoTwoDecimals } from '../../../../../util/util';
import HeroCard from '../../../../../../components/HeroCard/HeroCard';

const qqModuleHeroCard = ({ unitHighlights, onTabChange }) => {
  const heroTitle = 'Unit Highlights';
  const modalContent = (
    <div>
      <p><b>Assignments in this Unit</b> represents the total number of resources (readings, actvities, assessments) assigned to your students in this Unit.</p>
      <p><b>Students completed % of assignments</b> represents the proportion of assignments in this Unit completed across all students in your class.</p>
      <p><b>There are # students scoring below 60%</b> represents the number of students in your class who are earning below 60% on assesments in this Unit that measure proficiency (i.e. quizzes and tests where students are granted only one attempt per question).</p>
      <p><b>Students answered % questions correctly on first try</b> represents the proportion of questions in this Unit that were correct on a student&apos;s first try. This includes any question in this Unit answered by any student in your class.</p>
    </div>
  );

  const nullStateContent = () => {
    if (!unitHighlights || unitHighlights.assignments === -1) {
      return (<p>
        None of the unit activities have been assigned.<br />
        Go to the <button role="link" onClick={() => { onTabChange('assignments'); }}>Course Planner</button> tab to set up and manage assignments.
      </p>);
    }
    return null;
  };
  const lowScoringStudentsIsSingular = (unitHighlights.lowScoringStudents === 1);
  const assignmentsIsSingular = (unitHighlights.assignments === 1);
  const heroData = unitHighlights ? [
    {
      title: `There ${assignmentsIsSingular ? 'is' : 'are'}`,
      color: LEGEND_COLORS.BLACK,
      text: unitHighlights.assignments,
      bottomText: `${assignmentsIsSingular ? 'Assignment' : 'Assignments'} in this Unit`,
    },
    {
      title: 'Students Completed',
      color: LEGEND_COLORS.BLACK,
      text: unitHighlights.completedAssignmentsPercentage !== -1 ? `${roundtoTwoDecimals(unitHighlights.completedAssignmentsPercentage)}%` : '–',
      bottomText: 'of assignments',
    },
    {
      title: `There ${lowScoringStudentsIsSingular ? 'is' : 'are'}`,
      color: LEGEND_COLORS.BLACK,
      text: unitHighlights.lowScoringStudents !== -1 ? unitHighlights.lowScoringStudents : '–',
      bottomText: `${lowScoringStudentsIsSingular ? 'Student' : 'Students'} Scoring Below 60%`,
    },
    {
      title: 'Students Answered',
      color: LEGEND_COLORS.BLACK,
      text: unitHighlights.correctOnFirstTry !== -1 ? `${roundtoTwoDecimals(unitHighlights.correctOnFirstTry)}%` : '–',
      bottomText: 'Of Questions Correctly On Their First Try',
    },
  ] : [];

  return (<HeroCard
    className={style.qqReportCard}
    heroData={heroData}
    heroTitle={heroTitle}
    modalTitle={heroTitle}
    modalContent={modalContent}
    showNullStateMessage={!unitHighlights || unitHighlights.assignments === -1}
    nullStateMessage={nullStateContent()}

  />);
};

qqModuleHeroCard.propTypes = {
  unitHighlights: PropTypes.object,
  onTabChange: PropTypes.func,
};

export default qqModuleHeroCard;
